import { tv } from 'tailwind-variants';

const textareaGroupClasses = tv({
  base: 'flex flex-col gap-sm relative transition-all w-full',
  variants: {
    variant: {
      md: '',
      lg: '',
    },
    loading: {
      true: '',
    },
    hasError: {
      true: '',
    },
    disabled: {
      true: '',
    },
  },
});

const textareaClasses = tv({
  base: 'rounded-md ring-0 text-mono-color-black border-hairline bg-mono-color-white border-mono-color-dark peer focus:ring-0 focus:shadow-focused placeholder-transparent',
  variants: {
    variant: {
      md: 'p-3 text-md',
      lg: 'p-4 text-lg',
    },
    full: {
      true: 'w-full',
    },
    hasError: {
      true: 'border-feedback-color-error-pure focus:border-feedback-color-error-pure focus:shadow-error shadow-error',
    },
    disabled: {
      true: 'bg-mono-color-lighter text-mono-color-dark cursor-not-allowed focus:shadow-none border-mono-color-dark',
    },
    resize: {
      none: 'resize-none',
      vertical: 'resize-y',
      horizontal: 'resize-x',
      both: 'resize',
    },
  },
});

const labelClasses = tv({
  base: 'text-mono-color-black text-sm absolute bg-gradient-to-b from-color-transparent from-42.28% via-mono-color-white via-43.53% to-mono-color-white to-52.68% px-1 transition-all select-none pointer-events-none',
  variants: {
    variant: {
      md: `
        left-3
        -top-2 
        peer-focus:-top-2
        peer-focus:text-sm      
        peer-placeholder-shown:text-md
        peer-placeholder-shown:top-3
        !has-[:placeholder]:bg-mono-color-dark
    `,
      lg: `
        left-3
        -top-2

        peer-focus:-top-2
        peer-focus:text-sm
        peer-placeholder-shown:text-lg
        peer-placeholder-shown:top-3.5
        !has-[:placeholder]:bg-mono-color-dark
      `,
    },
    disabled: {
      true: 'text-mono-color-dark peer-placeholder-shown:bg-none',
    },
    forceUp: {
      true: '!-top-2 !text-sm',
    }
  },
});

const textAreaCharactersCountClasses = tv({
  base: 'text-sm text-mono-color-black absolute right-3 bottom-1.5',

  variants: {
    disabled: {
      true: 'text-mono-color-black',
    },
    hasErrorOrHelperText: {
      true: 'bottom-8',
    },
  },
});

const helperTextClasses = tv({
  base: 'text-sm',
  variants: {
    variant: {
      md: 'text-black',
    },
    disabled: {
      true: 'text-mono-color-dark',
    },
  },
});

const errorTextClasses = tv({
  base: 'text-sm text-feedback-color-error-pure',
  variants: {
    variant: {
      md: '',
      lg: '',
    },
    disabled: {
      true: 'text-mono-color-dark',
    },
  },
});

export {
  errorTextClasses,
  helperTextClasses,
  labelClasses,
  textAreaCharactersCountClasses,
  textareaClasses,
  textareaGroupClasses
};

